import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check if device is mobile
    if (this.isMobileDevice()) {
      return true; // Allow access on mobile
    } else {
      // Redirect desktop users to mobile-only page with return URL
      this.router.navigate(['/mobile-only'], { 
        queryParams: { returnUrl: state.url } 
      });
      return false;
    }
  }

  private isMobileDevice(): boolean {
    // Check screen width - only allow mobile phone sizes (≤480px)
    if (window.innerWidth <= 480) {
      return true;
    }

    // Check user agent for mobile phones only (exclude tablets)
    const userAgent = navigator.userAgent.toLowerCase();
    
    // Mobile phone keywords (exclude tablet indicators)
    const mobilePhoneKeywords = [
      'android', 'iphone', 'blackberry', 'windows phone', 'mobile'
    ];
    
    // Tablet keywords to exclude
    const tabletKeywords = ['ipad', 'ipod', 'tablet'];
    
    // Check if it's a mobile phone (has mobile keywords but NOT tablet keywords)
    const isMobilePhone = mobilePhoneKeywords.some(keyword => userAgent.includes(keyword));
    const isTablet = tabletKeywords.some(keyword => userAgent.includes(keyword));
    
    // Only return true if it's a mobile phone AND not a tablet
    return isMobilePhone && !isTablet;
  }
}
